<template>
    <imageLoader
        :src="url"
        :ratio="ratio"
        :alt="product.prodName"
        :srcError="srcError"
        @loaded="$emit('loaded')"
    />
</template>

<script>
import imageLoader from '@/components/imageLoader.vue';
import ctx from '@/utils/ctx';
import noProdImgSmall from '../assets/img/no_product_image_250.jpg';
import noProdImgLarge from '../assets/img/no_product_image_450.jpg';
import noProdImgDesp from '../assets/img/no_product_image_850.jpg';

const imageTypes = {
    small: 'prodSmallImgId',
    large: 'prodLrgImgId',
    desp: 'prodDespImgId',
    advrt: 'prodAdvrtImgId'
};

export default {
    components: { imageLoader },
    props: {
        product: { required: true },
        imageType: { default: 'small' }
    },
    computed: {
        url() {
            return ctx(
                (this.imageType === 'advrt'
                    ? '/advrtImage/'
                    : '/productImage/') +
                    this.product[imageTypes[this.imageType]]
            );
        },
        ratio() {
            if (this.imageType === 'desp') {
                return 800 / 450;
            }
            if (this.imageType === 'advrt') {
                return 540 / 960;
            }
            return 1;
        },
        srcError() {
            if (this.imageType === 'small') {
                return noProdImgSmall;
            } else if (this.imageType === 'large') {
                return noProdImgLarge;
            } else if (this.imageType === 'desp') {
                return noProdImgDesp;
            }
            return noProdImgLarge;
        }
    }
};
</script>
